import { InputFilterDto } from '@nccore/shared';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setApiHeaders } from '../../api';
import { environment } from '../../environments/environment';
import { InputFilterModel } from '../../models';

export const inputFilterApi = createApi({
  reducerPath: 'inputFilterApi',
  baseQuery: fetchBaseQuery({
    baseUrl: environment.apiHost + '/inputFilter',
    prepareHeaders: setApiHeaders,
  }),
  endpoints: (builder) => ({
    createInputFilter: builder.query<InputFilterModel, InputFilterDto>({
      query: (dto) => ({ method: 'POST', url: '', body: dto }),
      keepUnusedDataFor: 0,
    }),
    getInputFilter: builder.query<InputFilterModel, string>({
      query: (uuid) => ({ url: uuid }),
      keepUnusedDataFor: 0,
    }),
    updateInputFilter: builder.query<InputFilterModel, { uuid: string; dto: InputFilterDto }>({
      query: ({ uuid, dto }) => ({ method: 'PUT', url: uuid, body: dto }),
    }),
    deleteInputFilter: builder.query<InputFilterModel, string>({
      query: (uuid) => ({ method: 'DELETE', url: uuid }),
    }),
  }),
});

export const { useGetInputFilterQuery, useLazyCreateInputFilterQuery, useLazyUpdateInputFilterQuery, useLazyDeleteInputFilterQuery } = inputFilterApi;
